import React, { useState, FormEvent, useEffect } from 'react';

import { FormGroup, Button, HTMLTable, Position, Toaster, Intent, ProgressBar, Collapse, Checkbox  } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Dialog, DialogBody, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form';

import svgWait2 from './svg/wait2.gif'

import { SystemHeader } from './CommonUI';

var GsbFlag: any;


interface DayEndProcMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

interface TaskInfo {
    id: string,
    ref: string,
    description: string,
    startTime: string,
    endTime: string,
    userId: string,
    progressValue: number,
    progressMax: number,
    status: number,
    message: string,
    logFile: string
}


function DayEndProcMain({ gsb }: DayEndProcMainProps) {
    
    
    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    const [taskList, setTaskList] = useState([] as TaskInfo[])
    const [showTasks, setShowTasks] = useState(false)
    const [EndProcessMsg, setEndProcessMsg] = useState("")
    const [showButton, setshowButton] = useState(true)
    const [CanSkipWarning, setCanSkipWarning] = useState("0")

    const [ShowWait, setShowWait] = useState(true)
    const [ShowRpt, setShowRpt] = useState(false)
    const [ShowNoRecord, setShowNoRecord] = useState(false)

    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")
    const [isShowAlert3, setisShowAlert3] = useState(false)
    const [ShowAlert3Msg, setShowAlert3Msg] = useState([])
    const [isShowAlert4, setisShowAlert4] = useState(false)
    const [ShowAlert4Msg, setShowAlert4Msg] = useState([])

    const [s_toEps, sets_toEps] = useState("Y")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [userKey, setuserKey] = useState("")
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [Enter2tab, setEnter2tab] = useState("Y")

    const [SAS_MKT, setSAS_MKT] = useState(false)
    const [AVG_MUL_PRCE, setAVG_MUL_PRCE] = useState(false)
    const [HKIDR_USER1, setHKIDR_USER1] = useState(false)
    const [SI_USER, setSI_USER] = useState(false)
    const [SBF_USER, setSBF_USER] = useState(false)
    const [CC_READY, setCC_READY] = useState(false)
    const [GEN_INET, setGEN_INET] = useState(false)
    const [EPS_USER, setEPS_USER] = useState(false)
    const [isProduction, setisProduction] = useState(true)
 

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SmMastMain disp user_key: ", res.data.Flag.user_key)
                //console.log("SmMastMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("SmMastMain disp GsbFlag: ", GsbFlag)
                //console.log("SmMastMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("SmMastMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("SmMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setuserKey(GsbFlag.user_key) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                setEnter2tab(GsbFlag.Enter2tab) ;

                setSAS_MKT(GsbFlag.SAS_MKT)
                setAVG_MUL_PRCE(GsbFlag.AVG_MUL_PRCE)
                setHKIDR_USER1(GsbFlag.HKIDR_USER1)
                setSI_USER(GsbFlag.SI_USER)
                setSBF_USER(GsbFlag.SBF_USER)
                setCC_READY(GsbFlag.CC_READY)
                setGEN_INET(GsbFlag.GEN_INET)
                setEPS_USER(GsbFlag.EPS_USER)
                setisProduction(GsbFlag.isProduction == "Y")
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    
    useEffect(() => {
        if ( Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])


    useEffect(() => {
        if (taskList.findIndex((t: TaskInfo) => t.status === 0) > -1) {
            //console.log("running task(s) found, refresh tasklist in 1s")
            setTimeout(async () => {
                try {
                    const res = await gsb.post('/tasklist', taskList.map((t) => t.id));
                    //console.log("tasklist res.data.data", res.data.data)
                    setTaskList(res.data.data)
                } catch (error) {
                    utils.showError(error)
                }
            }, 2*1000)
        } else {
            //console.log("all task(s) completed.")
        }
    }, [taskList, gsb])

    useEffect(() => {
        {taskList.map((t, i) =>
            ( t.ref == "DayEndProc" && t.status == 1 ) && setisShowAlert1(true)   
        )}
        {taskList.map((t, i) =>
            ( t.ref == "DayEndProc" && t.status == 1 ) && setShowAlert1Msg("Day End Processing Completed. !!!")
        )}
    }, [taskList, gsb])

    useEffect(() => {
        setTimeout(async () => {
            setEndProcessMsg("")
            try {
                const res = await gsb.post('/SysMaint',
                    {   sb_data: {
                        //
                    },
                    cPgmId: "xProcess",
                });                
                if ( res.data.count > 0 ) {
                    if ( res.data.data[0].x_Porcessing.substr(2,13) == "DayEndProcess" ) {
                        setEndProcessMsg(res.data.data[0].x_Porcessing)
                    }
                }
            } catch (error) {
                utils.showError(error)
            }
        }, 3*1000)
    }, [taskList, gsb])


    const onDayEndProc1 = () => {
        //console.log("onDayEndProc fileInfoList", fileInfoList);
        setshowButton(false)
        setShowTasks(true)
        ;
        (async () => {
            try {
                const res = await gsb.post('/Transaction',
                    {   sb_data: {
                        s_toEps: s_toEps,
                        CanSkipWarning: CanSkipWarning
                    },
                    cPgmId: "DayEndProc",
                });                
                //console.log("onDayEndProc1 res.data.data.ok", res.data.data.ok)
                //console.log("onDayEndProc1 res.data.data", res.data.data)

                setTaskList(res.data.data)
                setShowTasks(true)
                if (! res.data.ok) {
                    //console.log("onDayEndProc1 res.data.Prompt_Msg", res.data.Prompt_Msg)
                    if (res.data.Prompt_Msg.isShowMsg) {
                        setisShowAlert3(true)
                        setShowAlert3Msg(res.data.Prompt_Msg.MsgShow)
                    } else if (res.data.Warning_Msg.isShowMsg) {
                        setisShowAlert4(true)
                        setShowAlert4Msg(res.data.Warning_Msg.MsgShow)
                    }
                }
            } catch (error) {
                showError(error)
            }
        })()
    }


    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            //toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
            //toaster.show({ message: (err.response.data.osCode > 0 ? "Error:"+err.response.data.subSystem +" - ": "")+err.response.data.description+(err.response.data.osCode > 0 ? ", OS code:"+err.response.data.osCode : ""), intent: Intent.WARNING })
            setisShowAlert2(true)
            setShowAlert2Msg((err.response.data.osCode > 0 ? "Error:"+err.response.data.subSystem +" - ": "")+err.response.data.description+(err.response.data.osCode > 0 ? ", OS code:"+err.response.data.osCode : ""))
        } else if (err.request) {
            //toaster.show({ message: "Request failed", intent: Intent.WARNING })
            setisShowAlert2(true)
            setShowAlert2Msg("Request failed")
        } else if (err.message) {
            //toaster.show({ message: err.message, intent: Intent.WARNING })
            setisShowAlert2(true)
            setShowAlert2Msg(err.message)
        } else {
            //toaster.show({ message: err, intent: Intent.WARNING })
            setisShowAlert2(true)
            setShowAlert2Msg(err)
        }
    
    }


    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }


    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>
            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <p><H3>Day End Processing 1</H3></p>
                    <div>
                        <div>Process : {EndProcessMsg}</div>
                    </div >
                    <div className="Spacing-V-8"></div>
                    { EPS_USER && <FormGroup className="Col-1-2" label="Copy Date Files to EPS">
                        <RadioGroup
                            inline={true}
                            disabled={isProduction}
                            selectedValue={s_toEps}
                            onChange={utils.handleStringChange(s => sets_toEps(s))  }
                        >
                            <Radio label="Yes"  value="Y" />
                            <Radio label="No"  value="N" />
                        </RadioGroup>
                    </FormGroup> }
                    <div className="Spacing-V-8"></div>
                    <div className="Row">
                        <Button className="Col-1-2" disabled={! showButton} icon={IconNames.LIST} onClick={onDayEndProc1}>Start Processing</Button>
                        <Button className="Col-3-1" icon={IconNames.LIST} onClick={() => setShowTasks(!showTasks)}>Tasks</Button>
                    </div>
                    <div className="Spacing-V-16"></div>
                    <Collapse isOpen={showTasks}>
                        <p>Tasks</p>
                        <HTMLTable striped interactive condensed>
                            <thead>
                                <th className="TCol-Ref">File Name</th>
                                <th className="TCol-Progress">Progress</th>
                                <th className="TCol-Message">Message</th>
                                <th className="TCol-Log">Log</th>
                            </thead>
                            <tbody>
                                {taskList.map((t, i) =>
                                    <tr key={i}>
                                        <td className="TCol-Ref">{t.ref}</td>
                                        <td className="TCol-Progress"><ProgressBar stripes={false} animate={false} value={t.progressValue / t.progressMax} /></td>
                                        <td className="TCol-Message">{t.message}</td>
                                        <td className="TCol-Log">{t.logFile && <a key={i} target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/logdownload?filename=${t.logFile}&inline`}>View</a>}</td>
                                    </tr>
                                )}
                            </tbody>
                        </HTMLTable>
                        {/*
                        <div className="Spacing-V-8"></div>
                        <div className="Row">
                            <Button className="Col-1-1" type="submit" icon={IconNames.CROSS} onClick={() => setShowTasks(!showTasks)}>Tasks</Button>
                        </div>
                        */}
                        <div className="Spacing-V-16"></div>
                        <Button className="Col-1-2" onClick={() => window.location.reload()}>Refresh Status</Button>
                        <div className="Spacing-V-16"></div>
                    </Collapse>
                    <br></br>
                    <p>Notes</p>
                    <div>
                        <div>Day End Processing include(s) :</div>
                        <div>- 44 Daily Transaction Register</div>
                        <div>- 45 Share Registration Worksheet</div>
                        <div>- 46 Register for Broker D/N</div>
                        <div>- 47 Payment/Receipt Worksheet (43 Client Cheque)</div>
                        <div>- 48 Payment/Receipt Register</div>
                        <div>- 49 CCASS Stock Receipt Register</div>
                        <div>- 4A Vault Stock Movement</div>
                        <div>- 4B Daily Rebate Report</div>
                        <div>- 4C Daily Stamp Return Report</div>
                        { SBF_USER && <div>- 4D Generate Transaction to Finance System</div> }
                        <br></br>
                        <div>- 52 Update Portfolio</div>
                        <div>- 55 Update Client Master Balance</div>
                        <div>- 56 Interest Calculation & Report</div>
                        <div>- 57 Extract Current Day Unsettled Transactions</div>
                        <div>- 58 Client Settled Transaction Report</div>
                        <div>- 59 Client Unsettled Transaction Report</div>
                        <div>- 5A Generate Client Trading History</div>
                        <div>- 5B Daily Summary Report</div>
                        <div>- 5C Trust A/C Report</div>
                        <div>- 5D Calculate Stock "CDF"</div>
                        <br></br>
                        <div>- 6 System End</div>
                        <br></br>
                        { GEN_INET && <div>- Export Files</div> }
                        <div>- Auto Download Holiday</div>
                        <br></br>
                        <div>- call batch xEnd.BAT if exist</div>
                    </div >
                </Card>
                <div className="Spacing-V-16"></div>
                <Alert
                    confirmButtonText="OK"
                    icon="tick-circle"
                    intent={Intent.SUCCESS}
                    isOpen={isShowAlert1}
                    onCancel={ () => setisShowAlert1(false) }
                    onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                >
                    <p>
                        {ShowAlert1Msg}
                    </p>
                </Alert>
                <Alert
                    confirmButtonText="OK"
                    icon="cross"
                    intent={Intent.DANGER}
                    isOpen={isShowAlert2}
                    onCancel={ () => setisShowAlert2(false) }
                    onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                >
                    <p>
                        {ShowAlert2Msg}
                    </p>
                </Alert>
                <Alert
                    confirmButtonText="OK"
                    icon="cross"
                    intent={Intent.DANGER}
                    isOpen={isShowAlert3}
                    onCancel={ () => setisShowAlert3(false) }
                    onConfirm={ () => { setShowAlert3Msg([]); setisShowAlert3(false) } }
                >
                    <p>
                        {/*ShowAlert3Msg*/}
                        <div className="Spacing-V-16"></div>
                        {ShowAlert3Msg.map((Wmsg, j) => 
                            <div>{ShowAlert3Msg[j]}</div>
                        )}
                    </p>
                </Alert>
                <Alert
                    cancelButtonText="No"
                    confirmButtonText="Yes"
                    icon="warning-sign"
                    intent={Intent.WARNING}
                    isOpen={isShowAlert4}
                    onCancel={ () => { setCanSkipWarning("1"); setshowButton(false); setisShowAlert4(false) } }
                    onConfirm={ () => { setCanSkipWarning("2"); setshowButton(true); setShowAlert4Msg([]); setisShowAlert4(false) } }
                >
                    <p>
                        {/*ShowAlert4Msg*/}
                        <div className="Spacing-V-16"></div>
                        {ShowAlert4Msg.map((Wmsg, j) => 
                            <div>{ShowAlert4Msg[j]}</div>
                        )}

                    </p>
                </Alert>
            </form>
        </>
    );
}

export default DayEndProcMain